import { WidgetState } from "@/apps/StudentExchangeNonPartnerWidget/models/store-viewmodel"
import actions from "@/apps/StudentExchangeNonPartnerWidget/store/actions"
import mutations from "@/apps/StudentExchangeNonPartnerWidget/store/mutations"
import getters from "@/apps/StudentExchangeNonPartnerWidget/store/getters"

export default {
    state: new WidgetState,
    actions: actions,
    mutations: mutations,
    getters: getters
}